<template>
  <div class="fieldset mt-4" v-if="subMenu && subMenuData">
    <legend class="md-whiteframe-z2" align="center">
      {{ subMenu["@attributes"].txtid | translate }}
    </legend>
    <v-flex v-if="subMenu.field.length" class="conection">
      <v-layout
        row
        wrap
        align-center
        pbb-2
        v-for="(fields, index) in subMenu.field"
        :key="fields['@attributes'].txtid + index"
      >
        <v-flex xs7 md7>
          <span class="subheading title-boil">
            {{ fields["@attributes"].txtid | translate }}
            <span v-if="fields['@attributes'].unittxt">
              {{ fields["@attributes"].unittxt | translate }}</span
            >
          </span>
        </v-flex>
        <v-flex xs4 md4>
          <v-btn
            v-if="
              fields['@attributes'].type === 'langModal' &&
                selectedLanguage.flag
            "
            small
            class="lang-button"
            @click="openLangDialog"
          >
            <country-flag :country="selectedLanguage.flag" size="normal" />
            <span class="lang-text">{{ selectedLanguage.name }}</span>
          </v-btn>
          <span
            class="subheading title-boil"
            v-if="fields['@attributes'].type === 'simpleText'"
          >
            {{ version }}
          </span>
          <span
            class="subheading title-boil"
            v-if="fields['@attributes'].type === 'versionText'"
          >
            {{ subMenuData[fields["@attributes"].udp].val }}
          </span>

          <v-select
            :key="accessFieldKey"
            v-if="
              fields['@attributes'].type === 'dropdown' &&
                fields['@attributes'].txtid === 'lng_nbe_auth_mode_setting'
            "
            v-long-press="800"
            @long-press-start="onTouchStart"
            :class="[advancedMode ? 'shake' : 'mt-0 pt-0']"
            :items="selectField[fields['@attributes'].fieldset].selectField"
            :value="getAccessMode"
            item-text="name"
            item-value="value"
            menu-props="auto"
            return-object
            @input="openTechDialog"
          ></v-select>
          <v-select
            @click.native="saveSelectFieldUdp(fields['@attributes'].udp)"
            v-if="
              fields['@attributes'].type === 'dropdown' &&
                selectField[fields['@attributes'].fieldset] &&
                fields['@attributes'].txtid !== 'lng_nbe_auth_mode_setting'
            "
            :disabled="readOnly ? true : false"
            class="mt-0 pt-0"
            :items="selectField[fields['@attributes'].fieldset].selectField"
            :value="selectedSelectField[fields['@attributes'].fieldset].val"
            item-text="name"
            item-value="value"
            menu-props="auto"
            return-object
            @change="saveSelectFieldData"
          ></v-select>
        </v-flex>
      </v-layout>
    </v-flex>
    <tech-access-dialog
      messageText="lng_tech_warning"
      messageTitle="lng_warning"
      :openDialog="techDialog"
      :closeDialog="closeTechDialog"
      :giveAccess="giveTechAccess"
    ></tech-access-dialog>
    <language-selection
      :selected-language="selectedLanguage"
      :openDialog="langDialog"
      :closeDialog="closeLangDialog"
    ></language-selection>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import GlobalService from "../services/global-service";
import { appVersion } from "../common/Constant";
import TechAccessDialog from "./TechAccessDialog";
import LanguageSelection from "./LanguageSelection";
import CountryFlag from "vue-country-flag";
import Langugaes from "../components/internationalization/languages";
import { translate } from "../common/HelperFunctions";

export default {
  name: "FieldItem",
  data() {
    return {
      version: appVersion,
      selectField: {},
      selectfieldData: [],
      selectedSelectField: {},
      techDialog: false,
      techAccessText: "lng_setup_teknik_mode_tp",
      selectFieldUdp: undefined,
      timeoutInstance: undefined,
      langDialog: false,
      selectedLanguage: {},
      advancedMode: false,
      selectedAccessObject: {},
      accessFieldKey: 0
    };
  },
  components: {
    TechAccessDialog,
    LanguageSelection,
    CountryFlag
  },
  props: {
    fields: {
      type: Object,
      default: () => {}
    },
    subMenu: {
      type: Object,
      default: undefined
    },
    subMenuData: {
      type: Object,
      default: () => {}
    },
    subMenuSelectData: {
      type: Array,
      default: () => []
    },
    responseAlert: {
      type: Function,
      default: undefined
    },
    keystrokeValue: {
      type: Number,
      default: 0
    }
  },
  watch: {
    keystrokeValue: function(newVal) {
      if (newVal >= 3) {
        this.advancedMode = true;
        this.selectFieldsInitialize();
      }
    }
  },
  created() {
    this.selectFieldsInitialize();
    this.selectedFieldsInitialize();
  },
  mounted() {
    this.selectedLanguage = this.showSelectedLang();
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
    ...mapGetters("global", ["getTechAccess"]),
    ...mapGetters("global", ["getAccessMode"]),
    readOnly() {
      return this.getUser.credentials === "readonly";
    }
  },
  methods: {
    onTouchStart() {
      this.$emit("showAdvancedMode");
    },
    showSelectedLang() {
      let storageLang = localStorage.getItem("language");
      if (storageLang) {
        let index = Langugaes.languages.findIndex(e => e.lang == storageLang);
        if (index >= 0) {
          return Langugaes.languages[index];
        }
      } else {
        localStorage.setItem("language", "uk");
        let index = Langugaes.languages.findIndex(e => e.lang == "uk");
        if (index >= 0) {
          return Langugaes.languages[index];
        }
      }
      return "none";
    },
    // open technical access dialog
    openTechDialog(field) {
      if (field.value !== "user" && !this.getTechAccess) {
        this.techDialog = true;
        this.selectedAccessObject = field;
      } else {
        // this.$store.commit("global/setTechAccess", false);
        this.changeAccessMode(field);
      }
    },
    // close technical access dialog
    closeTechDialog() {
      this.techDialog = false;
      this.accessFieldKey += 1;
    },
    // save technical access given
    giveTechAccess() {
      this.$store.commit("global/setTechAccess", true);
      this.techDialog = false;
      this.changeAccessMode(this.selectedAccessObject);

      clearTimeout(this.timeoutInstance);
      this.timeoutInstance = setTimeout(() => {
        this.$store.commit("global/setTechAccess", false);
        this.changeAccessMode({ value: "user" });
      }, 1800000);
    },
    // to update the dropdown field data
    async saveSelectFieldData(fieldData) {
      let response;
      try {
        response = await GlobalService.saveFieldData(
          this.selectFieldUdp,
          this.selectFieldUdp,
          this.getUser.token,
          fieldData.value
        );
      } catch (e) {
        var resObj = { status: 1, message: "Try again later" };
        this.responseAlert(resObj);
      }
      if (response.status === "0") {
        this.responseAlert(response);
      } else {
        this.responseAlert(response);
      }
    },
    // function to check field's auth
    checkFieldAccess(field) {
      // return field.auth === "smith" || field.auth === "nbe"
      //   ? !this.getTechAccess
      //   : false;
      return field.auth === this.getAccessMode ? false : true;
    },
    // to call a function in parent
    saveSelectFieldUdp(udp) {
      // this.$emit("saveSelectFieldUdp", udp);
      this.selectFieldUdp = udp;
    },
    // initilization of dropdown field values
    selectFieldsInitialize() {
      let selectFieldData = [];

      for (let i = 0; i < this.subMenuSelectData.length; i++) {
        this.$set(
          this.selectField,
          this.subMenuSelectData[i]["@attributes"].name,
          this.subMenuSelectData[i]
        );
        let subMenuSelectDataLength = this.subMenuSelectData[i].field.length;
        // remove nbe option form dropdown values
        if (
          this.subMenuSelectData[i]["@attributes"].name === "access_modes" &&
          this.keystrokeValue < 3 &&
          this.getAccessMode !== "nbe"
        ) {
          subMenuSelectDataLength = this.subMenuSelectData[i].field.length - 1;
        }
        for (let j = 0; j < subMenuSelectDataLength; j++) {
          if (selectFieldData[this.subMenuSelectData[i]["@attributes"].name]) {
            selectFieldData[this.subMenuSelectData[i]["@attributes"].name].push(
              {
                name: translate(
                  this.subMenuSelectData[i].field[j]["@attributes"].txtid
                ),
                value: this.subMenuSelectData[i].field[j]["@attributes"].value
              }
            );
          } else {
            selectFieldData[this.subMenuSelectData[i]["@attributes"].name] = [
              {
                name: translate(
                  this.subMenuSelectData[i].field[j]["@attributes"].txtid
                ),
                value: this.subMenuSelectData[i].field[j]["@attributes"].value
              }
            ];
          }
        }
        this.$set(
          this.selectField[this.subMenuSelectData[i]["@attributes"].name],
          "selectField",
          selectFieldData[this.subMenuSelectData[i]["@attributes"].name]
        );
      }
    },
    // a function to store the selected field of dropdown
    selectedFieldsInitialize() {
      let selectedFieldsdata = [];
      for (let j = 0; j < this.subMenu.field.length; j++) {
        if (this.subMenu.field[j]["@attributes"].type === "dropdown") {
          selectedFieldsdata[
            this.subMenu.field[j]["@attributes"].fieldset
          ] = this.subMenuData[this.subMenu.field[j]["@attributes"].udp];
        }
      }
      this.selectedSelectField = selectedFieldsdata;
    },
    openLangDialog() {
      this.langDialog = true;
    },
    // close Help text showing dialog
    closeLangDialog() {
      this.langDialog = false;
      this.selectedLanguage = this.showSelectedLang();
      this.$emit("saveLang");
    },
    // change access mode in vuex
    changeAccessMode(mode) {
      this.$store.commit("global/setAccessMode", mode.value);
      this.$emit("saveLang");
    }
  }
};
</script>
<style>
.conection .pbb-2:first-child {
  padding-bottom: 10px;
}
.lang-button .v-btn__content .lang-text {
  margin-left: 40px;
}
.lang-button .v-btn__content .flag {
  left: 0;
}
.shake {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}
.shake .v-input__slot {
  background-color: #fff;
}
@keyframes shake {
  10%,
  90% {
    transform: translate3d(-3px, 0, 0);
  }
  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }
  30%,
  50%,
  70% {
    transform: translate3d(-6px, 0, 0);
  }
  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>
